function MIPSLogo({ size }) {
    return (
      <svg height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 391.18 116.25">
        <g strokeWidth="0">
          <path
            fill="#101820"
            d="M192.1 114.5L191.97 27.04 171.61 27.04 141.56 67.57 110.88 27.04 90.52 27.04 90.52 114.5 113.26 114.5 113.26 69.39 135.62 95.88 146.62 95.88 169.14 68.1 169.36 114.5 192.1 114.5z"
          ></path>
          <path
            fill="#101820"
            d="M201.31 114.5V27.04h24.74v87.47h-24.74zM309.35 42.09c-3.12-4.87-7.6-8.6-13.43-11.18s-12.74-3.87-20.74-3.87h-39.86v87.47h24.74V91.64h15.12c8 0 14.91-1.31 20.74-3.94 5.83-2.62 10.31-6.33 13.43-11.12 3.12-4.79 4.68-10.56 4.68-17.31s-1.56-12.31-4.68-17.18zM285.3 68.7c-2.58 2.21-6.46 3.31-11.62 3.31h-13.62V46.52h13.62c5.16 0 9.04 1.15 11.62 3.44s3.87 5.39 3.87 9.31-1.29 7.23-3.87 9.43zM352.32 116.25c-7.25 0-14.18-.9-20.8-2.69-6.62-1.79-11.98-4.06-16.06-6.81l8.12-18.37c3.91 2.5 8.43 4.56 13.56 6.19 5.12 1.62 10.22 2.44 15.31 2.44 3.5 0 6.27-.29 8.31-.87 2.04-.58 3.54-1.42 4.5-2.5s1.44-2.37 1.44-3.87c0-1.91-.92-3.44-2.75-4.56-1.83-1.12-4.23-2.08-7.18-2.87-2.96-.79-6.16-1.54-9.62-2.25-3.46-.71-6.98-1.64-10.56-2.81-3.58-1.17-6.83-2.7-9.75-4.62-2.92-1.91-5.27-4.41-7.06-7.5-1.79-3.08-2.69-6.95-2.69-11.62 0-5.16 1.42-9.87 4.25-14.12s7.12-7.66 12.87-10.25c5.75-2.58 12.91-3.87 21.49-3.87 5.75 0 11.39.65 16.93 1.94 5.54 1.29 10.43 3.23 14.68 5.81l-7.5 18.24c-4.16-2.33-8.29-4.04-12.37-5.12s-8.04-1.62-11.87-1.62c-3.42 0-6.16.37-8.24 1.12-2.08.75-3.58 1.71-4.5 2.87-.92 1.17-1.37 2.42-1.37 3.75 0 2 .91 3.56 2.75 4.69 1.83 1.12 4.21 2.04 7.12 2.75s6.14 1.44 9.68 2.19 7.06 1.69 10.56 2.81c3.5 1.12 6.73 2.62 9.68 4.5 2.96 1.87 5.35 4.33 7.19 7.37 1.83 3.04 2.75 6.85 2.75 11.43 0 5.08-1.44 9.77-4.31 14.06-2.87 4.29-7.18 7.73-12.93 10.31s-12.95 3.87-21.62 3.87z"
          ></path>
          <path
            fill="#e60a95"
            d="M106.68 21.37L90.52 21.37 90.52 0.03 106.68 21.37z"
          ></path>
          <path
            fill="#101820"
            d="M85.52 58.18L56.43 29.09 85.52 0 85.52 58.18z"
          ></path>
          <path
            fill="#101820"
            d="M36.57 108.9L56.43 89.04 36.57 69.18 36.57 108.9z"
          ></path>
          <path
            fill="#e60a95"
            d="M29.01 11.82H34.410000000000004V96.11000000000001H29.01z"
            transform="rotate(-45 31.713 53.964)"
          ></path>
          <path
            fill="#e60a95"
            d="M35.53 5.3H40.93V89.59H35.53z"
            transform="rotate(-45 38.232 47.444)"
          ></path>
          <path
            fill="#e60a95"
            d="M42.06 -1.23H47.46V83.06H42.06z"
            transform="rotate(-45 44.751 40.924)"
          ></path>
          <path
            fill="#e60a95"
            d="M48.58 -7.75H53.98V76.54H48.58z"
            transform="rotate(-45 51.275 34.391)"
          ></path>
        </g>
      </svg>
    );
  }
  
  function ARMLogo({size}) {
    return (
      <svg
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        enableBackground="new 0 0 308.6 144.2"
        version="1.1"
        viewBox="0 0 308.6 144.2"
        xmlSpace="preserve"
      >
        <path
          fill="#0091BD"
          d="M89.4 37.9h15.9V106H89.4v-7.1c-7 8.1-15.5 9.2-20.4 9.2-21 0-33-17.5-33-36.2 0-22.2 15.2-35.8 33.2-35.8 5 0 13.8 1.3 20.2 9.7v-7.9zM52.3 72.3C52.3 84 59.7 94 71.2 94c10 0 19.3-7.3 19.3-21.5 0-14.9-9.2-22-19.3-22-11.5-.1-18.9 9.7-18.9 21.8zm71.9-34.4h15.9V44c1.8-2.1 4.4-4.4 6.6-5.7 3.1-1.8 6.1-2.3 9.7-2.3 3.9 0 8.1.6 12.5 3.2l-6.5 14.4c-3.6-2.3-6.5-2.4-8.1-2.4-3.4 0-6.8.5-9.9 3.7-4.4 4.7-4.4 11.2-4.4 15.7V106h-15.9l.1-68.1zm54.9 0H195v6.3c5.3-6.5 11.6-8.1 16.8-8.1 7.1 0 13.8 3.4 17.6 10 5.7-8.1 14.2-10 20.2-10 8.3 0 15.5 3.9 19.4 10.7 1.3 2.3 3.6 7.3 3.6 17.2v42.1h-15.9V68.7c0-7.6-.8-10.7-1.5-12.1-1-2.6-3.4-6-9.1-6-3.9 0-7.3 2.1-9.4 5-2.8 3.9-3.1 9.7-3.1 15.5v35.1h-15.9V68.7c0-7.6-.8-10.7-1.5-12.1-1-2.6-3.4-6-9.1-6-3.9 0-7.3 2.1-9.4 5-2.8 3.9-3.1 9.7-3.1 15.5v35.1h-15.5V37.9z"
          className="st0"
        ></path>
      </svg>
    );
  }

  export{ARMLogo, MIPSLogo}